import React from "react";

import CustomDropdown from "@cayuse/shared-react.custom-dropdown";
import { isNonEmptyArray, isNonEmptyString } from "@cayuse/shared-react.utils.type-checks";
import PropTypes from "prop-types";

import styles from "./styles.css";

const StatusDropdown = ({ options, value, disabled, ariaLabel, label, ...rest }) => {
	const hasStatus = isNonEmptyString(value);
	const hasOptions = isNonEmptyArray(options);

	return hasStatus && hasOptions
		? (
			<div className={styles.statusWrapper} role="application" aria-roledescription="dropdown">
				<CustomDropdown
					customClassname={styles.statusOverride}
					options={options}
					value={value}
					disabled={disabled}
					isCustomized={true}
					isCustomStyling={true}
					ariaLabel={ariaLabel}
					label={label}
					{...rest}
				/>
			</div>
		) : null;
};

StatusDropdown.propTypes = {
	disabled: PropTypes.bool,
	options: PropTypes.arrayOf(PropTypes.shape({
		className: PropTypes.string,
		disabled: PropTypes.bool,
		key: PropTypes.string,
		onClick: PropTypes.func,
		text: PropTypes.string,
		value: PropTypes.string
	})),
	ariaLabel: PropTypes.string,
	label: PropTypes.string,
	value: PropTypes.string
};

StatusDropdown.defaultProps = {
	disabled: false,
	options: [],
	value: ""
};

export default StatusDropdown;